import React from "react";
import {useSelector} from "react-redux";
import {pages} from "../../data/Pages";

export default function Main(){
    const page = useSelector((state) => state.page.currentPageId);

    return <div className="flex-1 overflow-y-auto bg-[#000000] p-0">
                 {pages[page].component}
    </div>
}
